'use strict';
'use es6';

// This is used if we can't get the navigationStart time from window.performance

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.now = now;
exports.navigationStart = navigationStart;
exports.millisecondsSinceNavigationStart = millisecondsSinceNavigationStart;
var initTime = +new Date();

var perfNow = undefined;
var navigationStartValue = undefined;

if (typeof window !== 'undefined' && window.performance) {
  if (window.performance.now) {
    perfNow = function perfNow() {
      return window.performance.now();
    };
  }

  if (window.performance.timing && window.performance.timing.navigationStart) {
    navigationStartValue = window.performance.timing.navigationStart;
  }
}

function now() {
  if (perfNow) {
    return perfNow();
  } else {
    return +new Date();
  }
}

function navigationStart() {
  if (navigationStartValue) {
    return navigationStartValue;
  } else {
    return initTime;
  }
}

function millisecondsSinceNavigationStart() {
  if (perfNow) {
    return Math.floor(perfNow());
  } else {
    return +new Date() - initTime;
  }
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/Reagan/static-7.24/js/timingUtils.js
// module id = 265
// module chunks = 0